import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Operators } from '../../../../components/Management'

// eslint-disable-next-line react/display-name
export default ({ match, ...rest }) => (
  <Switch>
    <Route path={`${match.path}`} render={() => <Operators match={match} {...rest} />} />
  </Switch>
)
